import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/move';

/** 状況 `move_after_activation`（組み立ては `../fx/move.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'move_after_activation', role: 'effect', ...spec }, 'move_after_activation_effect.js');
